import { render, staticRenderFns } from "./SeeAllStrategies.vue?vue&type=template&id=3130abd8&scoped=true"
import script from "./SeeAllStrategies.vue?vue&type=script&lang=js"
export * from "./SeeAllStrategies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3130abd8",
  null
  
)

export default component.exports